export default __webpack_public_path__ + "static/media/CNo.38-0.c94e6bf9.jpg";